function replaceAt<T = unknown>(array: T[], index: number, value: T): T[] {
  const returnValue = [...array]
  returnValue[index] = value
  return returnValue
}

export { replaceAt }
